export default __webpack_public_path__ + "static/media/3108.0da21d49.jpg";